import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import { HomePageMain } from '../pages/homepage';
import { APP_ROUTES } from '../constants/app-routes';
import {
  Transactions,
  Inbox,
  Venues,
  Dashboard,
  VendorEventGuide,
  Reviews,
  UpdateEvent,
  EventRegistration,
  VendorProfile,
  EventDetails,
  VendorPublicProfile,
  SearchEvents,
  SystemParameters,
  SearchVendors,
  VenueApplications,
  VenueProfile,
  VenueTransactions,
  RetailOpportunityDetails,
  RetailBooking,
  RetailPayments,
  EventPayments,
} from '../pages/app';
import Categories from '../pages/app/categories';
import PendingVenues from '../pages/app/venues/components/PendingVenues/PendingVenues';
import RegisteredVenues from '../pages/app/venues/components/RegisteredVenues';
import ManageReviews from '../pages/app/reviews/components/ManageReviews/ManageReviews';
import EventManagement from '../pages/app/event/event-management';
import AboutUs from '../pages/app/about-us';
import { GROUP_USER } from '../config/appGroupConfig';
import StripeValidationPage from '../pages/validation/StripeValidationPage';
import VenueTransactionsEvent from '../pages/app/dashboard/admin-dashboard/components/VenueTransactions/VenueTransactionsEvent';
import VenueTransactionsEventMM from '../pages/app/dashboard/admin-dashboard/components/VenueTransactions/VenueTransactionsEventMM';

export function FullRoutes() {
  const {
    HOME,
    MANAGE_VENUES,
    DASHBOARD,
    INBOX,
    VENDOR_EVENT_GUIDE,
    REVIEWS,
    VENDOR_EVENT_REGISTRATION,
    UPDATE_EVENT,
    VENDOR_PROFILE,
    EVENT_DETAILS,
    EVENT_MANAGEMENT: VENUE_EVENT_MANAGEMENT,
    CATEGORIES,
    VENDOR_PUBLIC_PROFILE,
    EVENTS_ADMIN_SEARCH,
    PENDING_VENUES,
    REGISTERED_VENUES,
    SYSTEM_PARAMETERS,
    MANAGE_REVIEWS,
    VENDORS_ADMIN_SEARCH,
    TRANSACTIONS,
    ABOUT_US,
    STRIPE_REDIRECT,
    VENUE_APPLICATIONS_ADMIN_SEARCH,
    VENUE_PUBLIC_PROFILE,
    VENUE_TRANSACTIONS,
    VENUE_TRANSACTIONS_EVENT,
    VENUE_TRANSACTIONS_EVENT_MONEY_MOVEMENT,
    RETAIL_OPPORTUNITY_DETAILS,
    RETAIL_BOOKING,
    RETAIL_PAYMENTS,
    EVENT_PAYMENTS,
  } = APP_ROUTES;

  return (
    <BrowserRouter>
      <Routes>
        {/* ADMIN role pages */}
        <Route element={<ProtectedRoute authGroups={[GROUP_USER.ADMIN]} />}>
          <Route key="admin-event-search" path={EVENTS_ADMIN_SEARCH} element={<SearchEvents />} />,
          <Route key="transactions" path={TRANSACTIONS} element={<Transactions />} />
          <Route
            key="venue-applications"
            path={VENUE_APPLICATIONS_ADMIN_SEARCH}
            element={<VenueApplications />}
          />
          <Route key="categories" path={CATEGORIES} element={<Categories />} />,
          <Route key="venue-pending" path={PENDING_VENUES} element={<PendingVenues />} />,
          <Route key="venue-registered" path={REGISTERED_VENUES} element={<RegisteredVenues />} />,
          <Route key="system-parameters" path={SYSTEM_PARAMETERS} element={<SystemParameters />} />,
          <Route key="manage-reviews" path={MANAGE_REVIEWS} element={<ManageReviews />} />,
          <Route
            key="admin-vendor-search"
            path={VENDORS_ADMIN_SEARCH}
            element={<SearchVendors />}
          />
          <Route
            key="admin-venue-transactions"
            path={VENUE_TRANSACTIONS}
            element={<VenueTransactions />}
          />
          <Route
            key="admin-venue-transactions/:venueId"
            path={VENUE_TRANSACTIONS_EVENT}
            element={<VenueTransactionsEvent />}
          />
          <Route
            key="admin-venue-transactions/:venueId/event/:eventId"
            path={VENUE_TRANSACTIONS_EVENT_MONEY_MOVEMENT}
            element={<VenueTransactionsEventMM />}
          />
        </Route>
        {/* VENDOR role pages */}
        <Route element={<ProtectedRoute authGroups={[GROUP_USER.VENDOR]} />}>
          <Route
            key="vendor-event-registration"
            path={VENDOR_EVENT_REGISTRATION}
            element={<EventRegistration />}
          />
          <Route key="vendor-profile" path={VENDOR_PROFILE} element={<VendorProfile />} />,
          <Route key="retail-payments" path={RETAIL_PAYMENTS} element={<RetailPayments />} />
          <Route key="event-payments" path={EVENT_PAYMENTS} element={<EventPayments />} />
        </Route>
        {/* VENUE role pages */}
        <Route element={<ProtectedRoute authGroups={[GROUP_USER.VENUE]} />}>
          <Route key="update-event" path={UPDATE_EVENT} element={<UpdateEvent />} />,
          <Route key="venues" path={MANAGE_VENUES} element={<Venues />} />,
          <Route
            key="event-management"
            path={VENUE_EVENT_MANAGEMENT}
            element={<EventManagement />}
          />
        </Route>
        {/* VENDOR & VENUE role pages */}
        <Route element={<ProtectedRoute authGroups={[GROUP_USER.VENDOR, GROUP_USER.VENUE]} />}>
          <Route key="reviews" path={REVIEWS} element={<Reviews />} />,
          <Route key="about-us" path={ABOUT_US} element={<AboutUs />} />,
        </Route>
        {/* ADMIN & VENUE role pages */}
        <Route element={<ProtectedRoute authGroups={[GROUP_USER.ADMIN, GROUP_USER.VENUE]} />}>
          <Route
            key="vendor-public-profile"
            path={VENDOR_PUBLIC_PROFILE}
            element={<VendorPublicProfile />}
          />
          <Route
            key="venue-public-profile"
            path={VENUE_PUBLIC_PROFILE}
            element={<VenueProfile />}
          />
          ,
        </Route>
        {/* LogIn user pages */}
        <Route
          element={
            <ProtectedRoute authGroups={[GROUP_USER.VENDOR, GROUP_USER.VENUE, GROUP_USER.ADMIN]} />
          }>
          <Route key="event-details" path={EVENT_DETAILS} element={<EventDetails />} />,
          <Route
            key="retail-opportunity-details"
            path={RETAIL_OPPORTUNITY_DETAILS}
            element={<RetailOpportunityDetails />}
          />
          <Route key="retail-booking" path={RETAIL_BOOKING} element={<RetailBooking />} />
          <Route key="inbox" path={INBOX} element={<Inbox />} />
          <Route
            key="vendor-event-guide"
            path={VENDOR_EVENT_GUIDE}
            element={<VendorEventGuide />}
          />
          ,
        </Route>
        <Route
          element={
            <ProtectedRoute
              authGroups={[GROUP_USER.VENDOR, GROUP_USER.VENUE, GROUP_USER.ADMIN]}
              redirectPath={HOME}
            />
          }>
          <Route key="/" path={DASHBOARD} element={<Dashboard />} />,
        </Route>
        <Route key="stripe" path={STRIPE_REDIRECT} element={<StripeValidationPage />} />,
        <Route key="home" path={HOME} element={<HomePageMain />} />,
        <Route path="*" element={<p>There&apos;s nothing here: 404!</p>} />,
      </Routes>
    </BrowserRouter>
  );
}
